import React from 'react';
import StudentVerification from './StudentVerification';
import WithdrawalVerification from './WithdrawalVerification';
import StudentDocumentation from './StudentDocumentation';

const Verification = ({ type }) => {
  switch (type) {
    case 'withdrawal':
      return <WithdrawalVerification />;
    case 'documentation':
      return <StudentDocumentation />;
    default:
      return <StudentVerification />;
  }
};

export default Verification; 